import styled from "styled-components";

export const FlexBox = styled.div`
  display: flex;
  justify-content: ${(props) => props.justify || "center"};
  align-items: ${(props) => props.align || "center"};
`;

export const InquiryBox = styled.div`
  background-color: ${(props) => (props.$selected ? "#ffc20e" : "white")};
  border: 1px solid ${(props) => (props.$selected ? "#ffc20e" : "#808080")};
  color: ${(props) => (props.$selected ? "white" : "black")};
  height: 100%;
  width: 150px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 36px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #ffc20e;
    border: 1px solid #ffc20e;
    color: white;
  }
`;
export const InquiryGroupBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 700px; */
  border: none;
  background-color: #f8f9fc;
  height: 40px;
  gap: 10px;
`;

export const FreeSizeBox = styled.div`
  width: ${(props) => props.width || "10px"};
  height: ${(props) => props.height || "10px"};
  justify-content: ${(props) => props.justify || "center"};
  align-items: ${(props) => props.align || "center"};
`;

export const ThFlex = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TdFlex = styled.td`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableTh = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableCategory = styled.div`
  border-bottom: 2px solid #ffc20e;
  margin-right: 30px;
  margin-left: 30px;
  font-weight: 800;
  font-size: 16px;
`;

export const ComentButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  border-radius: 16px;
  padding-right: 7px;
  padding-left: 7px;
  font-size: 11px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-weight: 800;
  background-color: #ffc20e;
  border: 1px solid #ffc20e;
  color: white;
`;

export const LockIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  color: #4d6483;
`;

export const BorderPwTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10vh;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
`;

export const PwButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: #ffc20e;
  font-weight: 700;
  color: white;
  font-size: 16px;
`;
export const PwButton2 = styled.button`
  width: 100%;
  padding: 10px;
  background-color: white;
  font-weight: 700;
  font-size: 16px;
`;

export const PwBackBox = styled.div`
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
`;

export const InputBackBox = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid ${(props) => (props.isFocused ? "#ffc20e" : "#D4D4D4")}; // 포커스에 따라 색상 변경
  width: 350px;
  margin-top: 5vh;
  background-color: white;
  border-radius: 8px;
  transition: border 0.2s ease;
`;

export const InputBackBox2 = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid ${(props) => (props.isFocused ? "#ffc20e" : "#D4D4D4")}; // 포커스에 따라 색상 변경
  width: 350px;
  /* margin-top: 5vh; */
  background-color: white;
  border-radius: 8px;
  transition: border 0.2s ease;
`;
export const AddTextButton = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffc20e;
  border-radius: 8px;
  background-color: white;
  color: black;
  font-weight: 700;
  font-size: 16px;
  padding-right: 20px;
  padding-left: 20px;
  cursor: pointer;
  margin-top: 20px;
  transition: all 0.3s ease;

  &:hover {
    color: white;
    background-color: #ffc20e;
  }
`;

export const FileInputFlex = styled.div`
  flex: ${(props) => props.$flex || 1};
  display: flex;
  text-align: center;
`;

export const FinalAddButton = styled.button`
  padding: 10px 20px;
  font-size: 28px;
  font-weight: 700;
  border-radius: 8px;
  border: 2px solid black;
  color: black;
  margin-top: 10px;
  transition: all 0.3s ease;

  &:hover {
    color: white;
    background-color: #ffc20e;
    border: 2px solid #ffc20e;
  }

  &:disabled {
    cursor: not-allowed;
    color: #d4d4d4;
    background-color: transparent;
    border: 2px solid #d4d4d4;

    &:hover {
      color: #d4d4d4;
      background-color: transparent;
      border: 2px solid #d4d4d4;
    }
  }
`;

export const PageNationBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const ListButton = styled.button`
  background-color: white;
  padding: 10px 20px;
  border: 1px solid gray;
  border-radius: 8px;
  font-weight: 700;
  transition: all 0.3s ease;

  &:hover {
    color: white;
    background-color: #ffc20e;
    border: 1px solid #ffc20e;
  }
`;

export const RelpysBox = styled.div`
  width: 100%;
  margin-top: 20px;
  border-top: 1px solid #808080;
  border-bottom: 1px solid #808080;
`;

export const RelpysComentBox = styled.div`
  background-color: #fcfcfc;
  width: 100%;
  border-bottom: 1px solid #808080;
  padding: 10px 20px;
`;

export const RelpysSpan = styled.span`
  border-bottom: 3px solid #ffc20e;
  font-weight: 700;
`;

export const RelpsPaddingBox = styled.div`
  padding: 10px 20px;
  position: relative;
  border: none;
  margin-top: 10px;
  border-radius: 8px;
  background-color: white;

  &:hover .action-buttons {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
`;

export const RelpysFlexCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const RelpysFont614 = styled.span`
  font-weight: 600;
  font-size: 14px;
  border-bottom: 2px solid #ffc20e;
`;

export const RelpysTimeBox = styled.div`
  margin-left: 10px;
  font-weight: 400;
  font-size: 10px;
  color: gray;
`;

export const RelpysText = styled.div`
  font-size: 12px;
`;

// export const RRelpysBox = sty;

export const SpinnerWrapper2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;

export const Spinner2 = styled.div`
  width: 140px;
  height: 140px;
  border: 5px solid #ffeecd;
  border-top-color: #ffc20e;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: auto;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ReplysSB = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReReplysButton = styled.button`
  /* border: ; */
  /* border-bottom: 2px solid #ffc20c; */
  font-size: 12px;
  font-weight: 500;

  &:hover {
    border: 1px solid #ffc20c;
    color: white;
    background-color: #ffc20c;
  }
`;

export const ActionButtonWrapper = styled(RelpysFlexCenter)`
  opacity: 0;
  transform: translateY(-5px);
  transition: all 0.3s ease-in-out;
  pointer-events: none; // 숨겨질 때 클릭 방지
  gap: 8px;

  &.action-buttons {
    // 그냥 className 확인용, 필수 아님
  }
`;

export const ReSaveButton = styled.button`
  min-width: 60px;
  font-weight: 700;
  margin-left: 20px;
  transition: all 0.3s ease;

  &:hover {
    color: white;
    background-color: #ffc20c;
    border: 1px solid #ffc20c;
  }
`;
